import { api } from '../../lib/api';
import { T, useGym } from '../../lib/gym';
import { useApi } from '../../lib/hooks';
import { useI18n } from '../../lib/i18n';
import { Card, ErrorBox, Loading, PageHeader } from '../../ui/components';

/** The member's card: their code as a barcode the desk scanner reads. */
export function PassPage() {
  const gym = useGym();
  const i18n = useI18n();
  const pass = useApi(() => api<any>(`${T(gym.slug)}/me/pass`), []);
  if (pass.error) return <div className="page"><ErrorBox error={pass.error} onRetry={pass.reload} /></div>;
  if (!pass.data) return <Loading />;
  return (
    <div className="page narrow">
      <PageHeader title={i18n.t('pass.title')} subtitle={i18n.t('pass.subtitle')} />
      <Card className="pass-card">
        <div className="pass-head">
          {gym.gym.branding?.logoUrl ? <img src={gym.gym.branding.logoUrl} alt={pass.data.gym} /> : <strong>{pass.data.gym}</strong>}
        </div>
        <div className="pass-name">{pass.data.name}</div>
        {pass.data.plan && <div className="small muted">{pass.data.plan}</div>}
        {pass.data.barcodeSvg
          ? <div className="pass-code" dangerouslySetInnerHTML={{ __html: pass.data.barcodeSvg }} />
          : <p className="warn">{i18n.t('pass.no_code')}</p>}
        {pass.data.memberNumber && <div className="small muted">#{pass.data.memberNumber}</div>}
      </Card>
      {pass.data.googleWalletUrl && (
        <a className="btn btn-secondary" href={pass.data.googleWalletUrl} target="_blank" rel="noreferrer">{i18n.t('pass.google_wallet')}</a>
      )}
      <p className="small muted">{i18n.t('pass.help')}</p>
    </div>
  );
}
